import {
  Dialog as MUIDialog,
  DialogTitle,
  DialogContent,
  Box,
  Stack,
} from '@mui/material';

import Button from '../../../components/styledComponents/Button';
import { RemoveButton } from '../../../components/styledComponents/IconButtons';
import colors from '../../../constants/colors';

interface UnenrollAutoPayDialogProps {
  closeDialog: () => void;
  open: boolean;
  confirmUnenroll: () => void;
  isLoading: boolean;
  discountBodyText?: string;
}

const UnenrollAutoPayDialog = ({
  closeDialog,
  open,
  confirmUnenroll,
  isLoading,
  discountBodyText,
}: UnenrollAutoPayDialogProps) => (
  <MUIDialog
    aria-labelledby="stopAutoPayLabel"
    data-testid="unenrollAutoPayDialog"
    open={open}
    onClose={closeDialog}
    sx={{ backdropFilter: 'blur(5px)' }}
    slotProps={{
      paper: {
        sx: {
          borderRadius: 4,
          margin: 0,
          px: { mobile: 3, tablet: 4 },
          position: { mobile: 'fixed', tablet: 'relative' },
          width: { mobile: 1, tablet: 480 },
          height: 'auto',
          maxHeight: 1,
        },
      }
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        width: 1,
        mt: { mobile: 2, tablet: 3 },
      }}
    >
      <RemoveButton
        aria-label="Close unenroll from autopay dialog"
        data-testid="closeIconUnenrollAutoPayDialogButton"
        onClick={closeDialog}
        autoFocus
      />
    </Box>
    <Stack spacing={3} sx={{ mt: 3, mb: 5 }}>
      <DialogTitle
        id="stopAutoPayLabel"
        sx={{
          fontSize: 28,
          fontWeight: 700,
          textAlign: 'center',
          color: colors.csaaBlack,
          lineHeight: '40px',
          p: 0,
        }}
      >
        Are you sure you want to stop AutoPay?
      </DialogTitle>
      {discountBodyText && (
        <DialogTitle
          sx={{
            fontSize: 18,
            fontWeight: 400,
            textAlign: 'center',
            color: colors.csaaBlack,
            lineHeight: '24px',
            p: 0,
          }}
        >
          {discountBodyText}
        </DialogTitle>
      )}
    </Stack>
    <Stack
      component={DialogContent}
      direction="column"
      spacing={2}
      sx={{
        pb: 6,
        px: 0,
        pt: 0,
      }}
    >
      <Button
        fullWidth
        data-testid="stopInstallmentFeesDialogButton"
        variant="outlined"
        color="inherit"
        sx={{
          borderWidth: 2,
          fontWeight: 700,
          textTransform: 'none',
          fontSize: 18,
          color: 'text.secondary',
          px: 4,
          py: 0.5,
        }}
        disableRipple
        onClick={confirmUnenroll}
        loading={isLoading}
      >
        Stop AutoPay
      </Button>
      <Button
        fullWidth
        data-testid="closeInstallmentFeesDialogButton"
        variant="contained"
        sx={{
          whiteSpace: 'nowrap',
          height: { mobile: 36, tablet: 42 },
        }}
        onClick={closeDialog}
      >
        Keep AutoPay
      </Button>
    </Stack>
  </MUIDialog>
);

export default UnenrollAutoPayDialog;
